import { data } from '@/config/data'
import { data_hausanker } from '@/config/data_hausanker'
import { slideNames } from '../config/enums'

export default {
  // note: tag manager
  SET_TAG_PROPERTY_VARIANT: (state, propertyVariant) => {
    state.tagVariant = propertyVariant
  },
  // note: default data.js, hausanker: data_hausanker.js
  SET_HAUSANKER_DATA: (state, data) => {
    state.slides = data
  },

  SET_DESIGN: (state, design) => {
    state.design = design
  },
  // note: default: 'DTK', if hausanker: 'HA'
  SET_SALESFORCE_DESIGN: (state, design) => {
    state.salesforce.forEach(sf => {
      if (sf.form_name === 'form_design') {
        // todo: change to be dynamic (for future design options)
        if (design === 'hausanker') {
          sf.value = 'HA'
        }
      }
    })
  },
  SET_VALIDATE_INPUT: state => {
    state.inputValidate = !state.inputValidate
  },

  USE_LS: state => {
    if (localStorage.getItem('dtkState') === null) {
      localStorage.setItem('dtkState', JSON.stringify(state))
    } else {
      const lsState = JSON.parse(localStorage.getItem('dtkState'))
      for (const key in lsState) {
        if (key !== 'el') {
          state[key] = lsState[key]
        }
      }
    }
  },

  SET_LS: state => {
    localStorage.removeItem('dtkState')
    localStorage.setItem('dtkState', JSON.stringify(state))
  },

  CLEAR_LS: state => {
    localStorage.removeItem('dtkState')
  },

  SET_NEXT: (state, payload) => {
    state.slides.forEach(slide => {
      if (slide.slideName === payload.slideName) {
        // enough 1 to be checked
        if (slide.forNext === 'one') {
          let nextEnabled = false
          slide.forms.forEach(form => {
            form.inputs.forEach(input => {
              if (input.selectedValue !== '') {
                nextEnabled = true
              }
            })
          })
          slide.nextEnabled = nextEnabled
        }
        // all have to be checked
        if (slide.forNext === 'all') {
          let nextEnabled = true
          slide.forms.forEach(form => {
            form.inputs.forEach(input => {
              if (!input.selectedValue && input.selectedValue !== 0) {
                nextEnabled = false
              }
            })
          })
          slide.nextEnabled = nextEnabled
        }
        // all have to be checked
        // checking allValues object
        if (slide.forNext === 'table') {
          let nextEnabled = true
          slide.forms.forEach(form => {
            for (const key in form.allValues) {
              if (!form.allValues[key]) {
                nextEnabled = false
              }
            }
          })
          slide.nextEnabled = nextEnabled
        }

        // checked-combined
        if (slide.forNext === 'check-combined') {
          let nextEnabled = false
          slide.forms.forEach(form => {
            form.inputs.forEach(input => {
              // has options
              if (input.options && input.options.length > 0) {
                input.options.forEach(option => {
                  if (option.selectedValue !== '') {
                    nextEnabled = true
                  }
                })
              }
              // doesn't have options
              else {
                if (input.selectedValue !== '') {
                  nextEnabled = true
                }
              }
            })
          })
          slide.nextEnabled = nextEnabled
        }
        // combined
        if (slide.forNext === 'combined') {
          let nextEnabled = true
          slide.forms
            // only showed forms
            .filter(f => f.showForm !== false)
            .forEach(form => {
              let nextEnabledForm = []
              // one
              if (form.forNext === 'one') {
                let nextEnabledOne = false
                form.inputs.forEach(input => {
                  if (input.selectedValue !== '') {
                    nextEnabledOne = true
                  }
                })
                nextEnabledForm.push(nextEnabledOne)
              }
              // all
              if (form.forNext === 'all') {
                let nextEnabledAll = true
                form.inputs.forEach(input => {
                  if (!input.selectedValue && input.selectedValue !== 0) {
                    nextEnabledAll = false
                  }
                })
                nextEnabledForm.push(nextEnabledAll)
              }
              // check all forms
              if (nextEnabledForm.includes(false)) {
                nextEnabled = false
              }
            })
          slide.nextEnabled = nextEnabled
        }
        // validation
        if (slide.forNext === 'validation') {
          let nextEnabled = true
          slide.forms.forEach(form => {
            form.inputs.forEach(input => {
              if (input.isInvalid === true) {
                nextEnabled = false
              }
            })
          })
          slide.nextEnabled = nextEnabled
        }
      }
    })
  },

  SET_CURRENT_SLIDE: (state, slideNum) => {
    state.currentSlide = slideNum
  },

  SET_DATA: (state, data) => {
    const {
      slideName,
      formName,
      value,
      name,
      showOptions,
      inputName,
      isInvalid
    } = data

    // FOR ALL SLIDES
    // set selectedValue on input
    // set nextEnable
    state.slides.forEach(slide => {
      if (slide.forms) {
        slide.forms.forEach(form => {
          // if radio table -> selectedValue is also on form
          if (
            slide.slideName === state.slideNames.SLIDE_17 &&
            slideName === state.slideNames.SLIDE_17
          ) {
            form.selectedValue = value
            form.inputs.forEach(input => {
              // find by formName and name
              if (
                input.formName.name === formName.name &&
                input.name === name
              ) {
                input.selectedValue = value
              }
            })
          } else {
            if (form.inputs) {
              form.inputs.forEach(input => {
                // find by formName and name
                if (input.formName === formName && input.name === name) {
                  input.selectedValue = value
                  input.isInvalid = isInvalid
                  input.showOptions = showOptions
                }
                if (input.formName === formName && input.name === inputName) {
                  input.options.forEach(option => {
                    if (option.name === name) {
                      option.selectedValue = value
                    }
                  })
                }
              })
            }
          }
        })
      }

      // SLIDE 3 - 1
      // if yes show form 3 - 2
      // if no delete value of 3 - 2
      if (
        slideName === state.slideNames.SLIDE_3 &&
        formName.name === state.formNames.FORM_3_1.name
      ) {
        state.slides.forEach(slide => {
          if (slide.slideName === state.slideNames.SLIDE_3) {
            slide.forms.forEach(form => {
              if (form.formName.name === state.formNames.FORM_3_2.name) {
                form.inputs.forEach(input => {
                  if (value === 'Ja') {
                    form.showForm = true
                  }
                  if (value === 'Nein') {
                    form.showForm = false
                    input.selectedValue = ''

                    // set salesforce ''
                    state.salesforce.forEach(sf => {
                      if (sf.name === state.formNames.FORM_3_2.name) {
                        sf.value = ''
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
    })
  },

  SET_VALUES_FORM_2_2: (state, value) => {
    state.slides.forEach(slide => {
      if (slide.slideName === state.slideNames.SLIDE_2) {
        slide.forms.forEach(form => {
          if (form.formName.name === state.formNames.FORM_2_2.name) {
            form.inputs.forEach(input => {
              // set max
              input.max = Math.ceil(value / 2)

              // set default
              input.default =
                Math.ceil(value / 4) > 100000 ? Math.ceil(value / 4) : 100000

              // set wunschbetrag to be default if no selected value
              if (!input.selectedValue) {
                state.wunschbetrag =
                  Math.ceil(value / 4) > 100000 ? Math.ceil(value / 4) : 100000
              }

              // set salesforce wunschbetrag to be default if no selected value
              state.salesforce.forEach(sf => {
                if (sf.name === state.formNames.FORM_2_2.name) {
                  sf.value = input.default
                }
              })
            })
          }
        })
      }
    })
  },

  SET_DATA_FROM_CALCULATOR_REDUCED: state => {
    state.slides.forEach(slide => {
      if (slide.slideName === slideNames.SLIDE_2) {
        slide.forms[0].inputs[0].selectedValue = state.immobilienwert
        slide.forms[1].inputs[0].selectedValue = state.wunschbetrag
        slide.forms[1].inputs[0].max = state.wunschbetragMax
      }
    })
  },

  SET_IMMOBILIENWERT: (state, value) => {
    state.immobilienwert = value
  },

  SET_WUNSCHBETRAG_MAX: (state, value) => {
    state.wunschbetragMax = Math.round(value / 2)
  },

  SET_WUNSCHBETRAG: (state, value) => {
    state.wunschbetrag = value
  },

  SET_HOHE_DER_LASTEN_VALUES: (state, value) => {
    state.slides.forEach(slide => {
      if (slide.slideName === state.slideNames.SLIDE_3) {
        slide.forms.forEach(form => {
          if (form.formName.name === state.formNames.FORM_3_2.name) {
            form.inputs.forEach(input => {
              input.max = value
              input.default = Math.ceil(value / 2)
            })
          }
        })
      }
    })
  },

  SET_PROPERTY_TYPE: (state, propertyType) => {
    state.propertyType = propertyType
  },

  SET_SLIDES_BY_PROPERTY_TYPE: (state, propertyType) => {
    // note: new design
    if (state.design === 'hausanker') {
      state.slides = data_hausanker.filter(slide =>
        slide.propertyTypes.includes(propertyType)
      )
    } else {
      state.slides = data.filter(slide =>
        slide.propertyTypes.includes(propertyType)
      )
    }

    // filter by calculator variant
    if (state.calculator_variant === 1) {
      state.slides = state.slides.filter(
        slide => slide.slideName !== state.slideNames.SLIDE_24
      )
    }
    if (state.calculator_variant === 2) {
      state.slides = state.slides.filter(
        slide =>
          slide.slideName !== state.slideNames.SLIDE_19 &&
          slide.slideName !== state.slideNames.SLIDE_20
      )
    }
  },

  SET_HAUS_TYPE: (state, hausType) => {
    state.hausType = hausType
  },

  TOGGLE_ADDITIONAL_OPTIONS_SLIDE_13: state => {
    state.slides.forEach(slide => {
      if (slide.slideName === state.slideNames.SLIDE_13) {
        slide.forms.forEach(form => {
          if (state.hausType === 7) {
            form.inputs.push({
              slideName: state.slideNames.SLIDE_13,
              formName: state.formNames.FORM_13_4,
              type: state.formTypes.SELECT,
              selectedValue: '',
              placeholder: 'Bitte wählen Sie aus',
              label: 'Anzahl der Wohneinheiten',
              name: 'Anzahl Einheiten MFH',
              style: 'center',
              validations: {},
              options: [
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '1',
                  value: '1'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '2',
                  value: '2'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '3',
                  value: '3'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '4',
                  value: '4'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '5',
                  value: '5'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '6',
                  value: '6'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '7',
                  value: '7'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '8',
                  value: '8'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '9',
                  value: '9'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '10',
                  value: '10'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_4,
                  label: '+10',
                  value: '11'
                }
              ]
            })
            form.inputs.push({
              slideName: state.slideNames.SLIDE_13,
              formName: state.formNames.FORM_13_5,
              type: state.formTypes.SELECT,
              selectedValue: '',
              placeholder: 'Bitte wählen Sie aus',
              label: 'Außenwohnbereich',
              name: 'Aussenwohnbereich MFH',
              style: 'center',
              validations: {},
              options: [
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_5,
                  label: 'keine nutzbaren',
                  value: 'keine'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_5,
                  label: 'Balkon/Loggia/Terrasse je < 10 m² Grundfläche',
                  value: 'Balkonkleiner10qm'
                },
                {
                  slideName: state.slideNames.SLIDE_13,
                  formName: state.formNames.FORM_13_5,
                  label: 'Balkon/Loggia/Terrasse je ≥ 10 m² Grundfläche',
                  value: 'Balkongroesser10qm'
                }
              ]
            })
            form.inputs.forEach(input => {
              input.marginSize = 'medium'
            })
          } else {
            // delete from data
            if (form.inputs.length > 3) {
              form.inputs.pop()
              form.inputs.pop()
            }
            // delete from salesforce
            state.salesforce.forEach(sf => {
              if (
                sf.name === state.formNames.FORM_13_4.name ||
                sf.name === state.formNames.FORM_13_5.name
              ) {
                sf.value = ''
              }
            })
            // delete margins
            form.inputs.forEach(input => {
              input.marginSize = ''
            })
          }
        })
      }
    })
  },

  HIDE_SLIDE_18: state => {
    state.slides = state.slides.filter(
      slide => slide.slideName !== state.slideNames.SLIDE_18
    )
    state.salesforce.forEach(sf => {
      if (sf.name === state.formNames.FORM_18_1.name) {
        sf.value = ''
      }
    })
  },

  SHOW_SLIDE_18: state => {
    // note: new design
    let slide18
    if (state.design === 'hausanker') {
      slide18 = data_hausanker.find(
        slide => slide.slideName === state.slideNames.SLIDE_18
      )
    } else {
      slide18 = data.find(
        slide => slide.slideName === state.slideNames.SLIDE_18
      )
    }
    const index = state.currentSlide + 1
    // insert on index slide18 and delete 0
    state.slides.splice(index, 0, slide18)
  },

  SET_VARIANT: (state, variant) => {
    state.calculator_variant = variant
  },

  HIDE_SLIDE_19: state => {
    state.slides = state.slides.filter(
      slide => slide.slideName !== state.slideNames.SLIDE_19
    )
  },

  HIDE_SLIDE_20: state => {
    state.slides = state.slides.filter(
      slide => slide.slideName !== state.slideNames.SLIDE_20
    )
  },

  HIDE_SLIDE_24: state => {
    state.slides = state.slides.filter(
      slide => slide.slideName !== state.slideNames.SLIDE_24
    )
  },

  // SLIDE 21
  SET_ADDRESS: (state, data) => {
    const { name, value, formName } = data
    state.slides.forEach(slide => {
      if (slide.slideName === state.slideNames.SLIDE_21) {
        slide.forms.forEach(form => {
          let isSelected = false
          form.inputs.forEach(input => {
            if (input.formName.name === state.formNames.FORM_21_7.name) {
              isSelected = input.selectedValue
            }
          })
          // only if das angebot is false
          if (!isSelected) {
            form.inputs.forEach(input => {
              if (input.name === name) {
                input.selectedValue = value
              }
              // set salesforce of 21 by title (title must be the same for 19 and 21)
              state.salesforce.forEach(sf => {
                if (
                  sf.title === formName.title &&
                  (sf.name === state.formNames.FORM_21_8_1.name ||
                    sf.name === state.formNames.FORM_21_8_2.name ||
                    sf.name === state.formNames.FORM_21_9.name ||
                    sf.name === state.formNames.FORM_21_10.name)
                ) {
                  sf.value = value
                }
              })
            })
          }
        })
      }
    })
  },

  SET_OTHER_ADDRESS_CHECKBOX: state => {
    state.otherAddressCheckbox = !state.otherAddressCheckbox
  },

  TOGGLE_ADDITIONAL_INPUTS: state => {
    state.slides.forEach(slide => {
      if (slide.slideName === state.slideNames.SLIDE_21) {
        slide.forms.forEach(form => {
          form.inputs.forEach(input => {
            if (
              input.formName.name === state.formNames.FORM_21_8_1.name ||
              input.formName.name === state.formNames.FORM_21_8_2.name ||
              input.formName.name === state.formNames.FORM_21_9.name ||
              input.formName.name === state.formNames.FORM_21_10.name
            ) {
              input.disabled = !input.disabled
              // delete values
              if (!input.disabled) {
                input.selectedValue = ''
              }
              // insert values from 19 or 24 (titles should be the same)
              else {
                state.slides.forEach(s => {
                  if (
                    s.slideName === state.slideNames.SLIDE_19 ||
                    s.slideName === state.slideNames.SLIDE_24
                  ) {
                    s.forms.forEach(f => {
                      f.inputs.forEach(i => {
                        if (i.formName.title === input.formName.title) {
                          input.selectedValue = i.selectedValue
                        }
                      })
                    })
                  }
                })
              }
            }
          })
        })
      }
    })
  },

  CLEAN_RADIO: (state, payload) => {
    const { slideName, formName, value, name, inputName } = payload
    state.slides[state.currentSlide].forms.forEach(form => {
      if (form.formName.name === formName.name) {
        form.inputs.forEach(input => {
          if (inputName === input.name) {
            // clean other options
            input.options.forEach(option => {
              if (option.name !== name) {
                option.selectedValue = ''
              }
            })
          } else if (input.name !== name) {
            // clean input
            input.selectedValue = ''
            input.showOptions = false
            if (input.options) {
              // clean options of other inputs
              input.options.forEach(option => {
                option.selectedValue = ''
              })
            }
          }
        })
      }
    })
  },

  // SLIDE 7
  SET_ADDITIONAL_OPTIONS_SLIDE_7: (state, payload) => {
    state.slides[state.currentSlide].forms.forEach(form => {
      form.inputs.forEach(input => {
        if (input.options) {
          input.options.forEach(option => {
            if (option.name === payload.name) {
              option.selectedValue = payload.value
            }
            // delete for option for input-1 and input-2
            else {
              option.selectedValue = ''
            }
          })
        }
      })
    })
  },

  // SLIDE 10
  TOGGLE_ITEMS: (state, payload) => {
    const { value } = payload
    // 10_1 - input
    if (value === 'balkon/terrasse') {
      if (state.slides[state.currentSlide].forms[0].inputs[0].selectedValue) {
        state.slides[state.currentSlide].forms[0].inputs[0].selectedValue = ''
        state.slides[state.currentSlide].forms[0].inputs[0].showOptions = false
        state.slides[
          state.currentSlide
        ].forms[0].inputs[0].options[0].selectedValue = ''
        state.slides[
          state.currentSlide
        ].forms[0].inputs[0].options[1].selectedValue = ''
      } else {
        state.slides[
          state.currentSlide
        ].forms[0].inputs[0].selectedValue = value
        state.slides[state.currentSlide].forms[0].inputs[0].showOptions = true
        state.slides[state.currentSlide].forms[0].inputs[2].selectedValue = ''
      }
    }
    // 10_1 - option 1
    else if (value === 'bis 10m2') {
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[0].selectedValue = value
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[1].selectedValue = ''
    }
    // 10_1 - option 2
    else if (value === 'ueber 10m2') {
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[0].selectedValue = ''
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[1].selectedValue = value
    }
    // 10_2 - JA
    else if (value === 'Ja') {
      if (state.slides[state.currentSlide].forms[0].inputs[1].selectedValue) {
        state.slides[state.currentSlide].forms[0].inputs[1].selectedValue = ''
      } else {
        state.slides[
          state.currentSlide
        ].forms[0].inputs[1].selectedValue = value
        state.slides[state.currentSlide].forms[0].inputs[2].selectedValue = ''
      }
    }
    // 10_2 - NEIN
    else if (value === 'Nein') {
      state.slides[state.currentSlide].forms[0].inputs[0].selectedValue = ''
      state.slides[state.currentSlide].forms[0].inputs[0].showOptions = false
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[0].selectedValue = ''
      state.slides[
        state.currentSlide
      ].forms[0].inputs[0].options[1].selectedValue = ''
      state.slides[state.currentSlide].forms[0].inputs[1].selectedValue = ''
      state.slides[state.currentSlide].forms[0].inputs[2].selectedValue = value
    }
    // check next
    if (
      (state.slides[state.currentSlide].forms[0].inputs[0].showOptions &&
        !state.slides[state.currentSlide].forms[0].inputs[0].options[0]
          .selectedValue &&
        !state.slides[state.currentSlide].forms[0].inputs[0].options[1]
          .selectedValue) ||
      (!state.slides[state.currentSlide].forms[0].inputs[0].selectedValue &&
        !state.slides[state.currentSlide].forms[0].inputs[1].selectedValue &&
        !state.slides[state.currentSlide].forms[0].inputs[2].selectedValue)
    ) {
      state.slides[state.currentSlide].nextEnabled = false
    } else {
      state.slides[state.currentSlide].nextEnabled = true
    }
  },

  SKIP_SLIDE_0: state => {
    state.currentSlide = 1
  },

  SET_EL: (state, el) => {
    state.el = el
  },

  SET_HIDDEN_INPUT: (state, payload) => {
    const { propName, value } = payload
    state.salesforce.forEach(sf => {
      if (sf.form_name === propName) {
        sf.value = value
      }
    })
    state.hiddenInputsArray.forEach(input => {
      if (input.form_name === propName) {
        input.value = value
      }
    })
  },

  SET_SALESFORCE: (state, payload) => {
    state.salesforce.forEach(sf => {
      if (sf.name === payload.formName.name) {
        // FORM 0_1
        if (payload.formName.name === state.formNames.FORM_0_1.name) {
          if (payload.value === state.propertyTypes.APARTMENT) {
            sf.value = 'Eigentumswohnung'
          } else {
            sf.value = ''
          }
        } else if (payload.formName.name === state.formNames.FORM_1_1.name) {
          sf.value = payload.value
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_0_1.name) {
              s.value = payload.value_0
            }
          })
        }

        // FORM 4_1 -> is not required, so if select 4_2 and 4_1 is empty, set default value to 4_1 (1)
        else if (payload.formName.name === state.formNames.FORM_4_2.name) {
          sf.value = payload.value
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_4_1.name) {
              if (!s.value) {
                s.value = 1
              }
            }
          })
        }

        // FORM 7_1 - if input 3 -> 7_2 value = 'nichtausgebaut'
        else if (
          payload.formName.name === state.formNames.FORM_7_1.name &&
          payload.value === 'nichtunterkellert'
        ) {
          sf.value = payload.value
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_7_2.name) {
              s.value = 'nichtausgebaut'
            }
          })
        }

        // FORM 10 - merge with additional options
        else if (payload.inputName === 'Balkon Terrasse') {
          if (payload.value === 'bis 10m2') {
            sf.value = 'Balkonkleiner10qm'
          }
          if (payload.value === 'ueber 10m2') {
            sf.value = 'Balkongroesser10qm'
          }
        }
        // FORM 10 - for first input to toggle
        else if (payload.value === 'balkon/terrasse') {
          sf.value = sf.value ? '' : payload.value
        }
        // FORM 10 - ja
        else if (
          payload.value === 'Ja' &&
          payload.formName.name === state.formNames.FORM_10_2.name
        ) {
          sf.value = !sf.value || sf.value === 'Nein' ? payload.value : ''
        }
        // FORM 10 - nein
        else if (
          payload.value === 'Nein' &&
          payload.formName.name === state.formNames.FORM_10_2.name
        ) {
          sf.value = payload.value
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_10_1.name) {
              s.value = ''
            }
          })
        }
        // FORM 21_12 - checkbox true = 1, false = ''
        else if (payload.formName.name === state.formNames.FORM_21_12.name) {
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_21_12.name) {
              s.value = payload.value ? 1 : ''
            }
          })
        }
        // FORM 21_13 - checkbox true = Ja, false = Nein
        else if (payload.formName.name === state.formNames.FORM_21_13.name) {
          state.salesforce.forEach(s => {
            if (s.name === state.formNames.FORM_21_13.name) {
              s.value = payload.value ? 'Ja' : 'Nein'
            }
          })

          // note: comment-out: checkboxes has to be independent because of german law (first checkbox is mandatory)
          // // DISABLE OTHER CHECKBOX
          // state.slides.forEach(slide => {
          //   if (slide.slideName === state.slideNames.SLIDE_21) {
          //     slide.forms.forEach(form => {
          //       form.inputs.forEach(input => {
          //         if (input.formName.name === state.formNames.FORM_21_7.name) {
          //           if (payload.value) {
          //             input.disabled = true
          //           } else {
          //             input.disabled = false
          //           }
          //         }
          //       })
          //     })
          //   }
          // })

          // 19 or 24 -> 21 (if empty)
          state.slides.forEach(slide => {
            if (slide.slideName === state.slideNames.SLIDE_21) {
              slide.forms.forEach(form => {
                form.inputs.forEach(input => {
                  if (
                    input.formName.name === state.formNames.FORM_21_8_1.name ||
                    input.formName.name === state.formNames.FORM_21_8_2.name ||
                    input.formName.name === state.formNames.FORM_21_9.name ||
                    input.formName.name === state.formNames.FORM_21_10.name
                  ) {
                    // disable/enable inputs
                    // other address checkbox
                    if (
                      payload.formName.name === state.formNames.FORM_21_7.name
                    ) {
                      if (payload.value) {
                        input.disabled = true
                      } else {
                        input.disabled = false
                      }
                    }
                    // note: comment-out: checkboxes has to be independent because of german law (first checkbox is mandatory)
                    // // email checkbox
                    // if (
                    //   payload.formName.name === state.formNames.FORM_21_13.name
                    // ) {
                    //   // checked -> disable inputs
                    //   if (payload.value) {
                    //     input.disabled = true
                    //   }
                    //   // unchecked -> disable inputs only if otherAddressCheckbox not checked
                    //   else {
                    //     if (state.otherAddressCheckbox) {
                    //       input.disabled = false
                    //     }
                    //   }
                    // }

                    // state.slides.forEach(s => {
                    //   if (
                    //     s.slideName === state.slideNames.SLIDE_19 ||
                    //     s.slideName === state.slideNames.SLIDE_24
                    //   ) {
                    //     s.forms.forEach(f => {
                    //       f.inputs.forEach(i => {
                    //         if (i.formName.title === input.formName.title) {
                    //           if (!input.selectedValue) {
                    //             input.selectedValue = i.selectedValue
                    //           }
                    //         }
                    //       })
                    //     })
                    //   }
                    // })
                  }
                })
              })
            }
          })
        }
        // ALL OTHER
        else {
          sf.value = payload.value
        }
      }
      // NOTE: FORM 0_2 -> additional info based on selected wohnung/haus for sending to salesforce
      if (sf.name === state.formNames.FORM_0_2.name) {
        if (state.propertyType === state.propertyTypes.HOUSE) {
          sf.value = 'Volleigentum'
        } else {
          sf.value = 'Wohnungseigentum'
        }
      }
    })
  }
}
